<!--  -->
<template>
  <div class="home" v-title data-title="租户保-保单管理系统">
    <div class="home-wrap">
      <div class="showimg">
        <div class="logo">
          <img src="@/assets/img/logo.png" alt="" />
        </div>
        <div class="title">
          <div>{{ property.name }}物业公司</div>
          <div class="title-name">租户保险保单</div>
          <div class="title-name">管理系统</div>
        </div>
        <img class="homeimg" src="@/assets/img/home02.png" alt="" />
      </div>
      <div class="container">
        <div class="header">
          <div>保险要求</div>
        </div>
        <div class="middle">
          <div class="title">{{ insurerInfo.name }}</div>
          <div class="text-item">
            <span>01.</span>
            <div class="text-item-container">
              <div>物质损失保险部分，保额按照实际工程造价</div>
            </div>
          </div>
          <div class="text-item">
            <span>02.</span>
            <div class="text-item-container">
              <div>第三者责任保险部分</div>
              <div>每次事故及累计赔偿限额不低于200万元</div>
              <div>每次事故每人人身伤亡赔偿限额不低于50万元</div>
            </div>
          </div>
          <div class="text-item no-border">
            <span>03.</span>
            <div class="text-item-container">
              <div>
                将{{ property.name }}物业公司列为附加被保险人/保单受益人
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="homebtn">
        <div class="buy-policy-btn" @click="tobuyPolicy">
          购买保单
          <i class="iconfont icon-youjiantou"></i>
          <!-- <p class="buy-policy-btn-bottom">BUY</p> -->
        </div>
        <div class="submit-btn" @click="submit">
          保单审核
          <i class="iconfont icon-youjiantou"></i>
          <p>(已购买)</p>
          <!-- <p class="buy-policy-btn-bottom">CHECK</p> -->
        </div>
      </div>
      <div class="footer">
        <a href="https://beian.miit.gov.cn/">沪ICP备09060181号-9</a>
      </div>
    </div>
    <!-- <div class="login-wrap">
      <div class="container">
        <el-form :model="userForm" ref="loginForm">
          <el-form-item prop="phone" label="手机号">
            <el-input
              v-model="userForm.phone"
              placeholder="请输入账号"
            ></el-input>
          </el-form-item>
          <el-form-item class="code" prop="password" label="验证码">
            <el-input
              v-model="userForm.code"
              placeholder="请输入密码"
              show-password
            ></el-input>
            <el-button
              :class="{ disabled: !this.canClick }"
              @click="getCode"
              type="primary"
              >{{ content }}</el-button
            >
          </el-form-item>
          <el-form-item class="login-btn">
            <el-button type="primary" @click="submitLoginForm">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div> -->
    <mt-popup v-model="popupVisible" popup-transition="popup-fade">
      <div class="container">
        <el-form :model="userForm" ref="loginForm">
          <el-form-item prop="phone" label="手机号">
            <el-input
              v-model="userForm.phone"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item class="code" prop="password" label="验证码">
            <el-input
              v-model="userForm.code"
              placeholder="请输入验证码"
            ></el-input>
            <el-button
              :class="{ disabled: !this.canClick }"
              @click="getCode"
              type="primary"
              >{{ content }}</el-button
            >
          </el-form-item>
          <el-form-item class="login-btn">
            <el-button type="primary" @click="submitLoginForm">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </mt-popup>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// import { UserLoginApi } from "@/api";
import { getLoginApi, getCodeApi, getInsurerListApi } from "@/api";
import { setToken } from "@/utils/auth.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      popupVisible: false,
      userForm: {
        phone: "",
        code: "",
      },
      content: "发送验证码", // 按钮里显示的内容
      totalTime: 60, //记录具体倒计时时间
      canClick: true, //添加canClick
      company_name: "XX",
      insurerInfo: {},
      property: {},
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    submit() {
      this.$router.push({
        name: "Upload",
      });
    },
    tobuyPolicy() {
      var token = localStorage.getItem("token");
      if (token == null) {
        this.popupVisible = true;
      } else {
        this.$router.push({
          name: "Quotation",
        });
      }
    },
    countDown() {
      if (!this.canClick) return; //改动的是这两行代码
      this.canClick = false;
      this.content = this.totalTime + "s后重新发送";
      let clock = window.setInterval(() => {
        this.totalTime--;
        this.content = this.totalTime + "s后重新发送";
        if (this.totalTime < 0) {
          window.clearInterval(clock);
          this.content = "发送验证码";
          this.totalTime = 60;
          this.canClick = true; //这里重新开启
        }
      }, 1000);
    },

    getCode() {
      // console.log(this.totalTime, this.canClick);
      if (this.canClick == true) {
        getCodeApi({ phone: this.userForm.phone }).then((res) => {
          // console.log(res.data.data.code);
          this.countDown();
          this.code = res.data.data.code;
        });
      }
    },
    getInsurerList() {
      getInsurerListApi().then((res) => {
        this.insurerInfo = res.data.data.insurances[0];
        this.property = res.data.data.property;
        // console.log(this.insurerInfo);
      });
    },
    submitLoginForm() {
      getLoginApi(this.userForm).then((res) => {
        // console.log(res.data.data.token);
        if (res.data.status == 1) {
          setToken("token", res.data.data.token, 1 * 24 * 7);
          var time2 = Date.now();
          localStorage.setItem("tokentime", time2);
          this.popupVisible = false;
          this.$store.commit("phone", this.userForm.phone);
        }
      });
    },
  },
  beforeCreate() {}, //生命周期 - 创建之前
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  beforeMount() {}, //生命周期 - 挂载之前
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getInsurerList();
  },
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less">
.home {
  display: flex;
  height: 100%;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  .home-wrap {
    width: 100%;
    height: 100%;
    // height: 650px;
    overflow: hidden;
    box-sizing: border-box;
    // border: 0.1rem solid red;
    background: #f1f1f1;
    padding: 1.6rem;
    padding-top: 0rem;
    position: relative;
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .login-btn {
        .el-button {
          background: linear-gradient(to top, #ef8400, #f7d94b);
          color: #ffffff;
          padding: 10px 20px !important;
          border-radius: 20px;
        }
      }
    }

    .showimg {
      position: relative;
      height: 20rem;
      .logo {
        height: 5rem;
        width: 15.6rem;
        
        margin-top: 2rem;
        img {
          height: 100%;
          width: 100%;
        }
      }
      .homeimg {
        position: absolute;
        top: 5rem;
        left: 1rem;
        width: 90%;
        height: 100%;
        z-index: 0;
      }
      .title {
        position: absolute;
        top: 0.7rem;
        right: 0;
        font-size: 2.6rem;
        text-align: right;
        z-index: 3;
        .title-name {
          font-size: 2.9rem;
          color: #1556bb;
          font-weight: bold;
        }
      }
    }
    .container {
      .header {
        font-size: 2.6rem;
        div {
          width: auto;
          background: linear-gradient(to right, #1556bc, #1569e3);
          padding: 0.8rem 2rem;
          border-radius: 26px;
          letter-spacing: 8px;
          color: #fff;
          z-index: 3;
        }
      }
      .middle {
        padding: 1rem;
        background: #fff;
        border-radius: 8px;
        box-shadow: 4px 4px 4px 4px #c3c3c3;
        position: relative;
        z-index: 3;
        .title {
          color: #1469e2;
          font-weight: bold;
          font-size: 2rem;
        }
        .text-item {
          display: flex;
          align-items: flex-start;
          padding: 1.5rem 0;
          border-bottom: 1px dashed #939393;
          span {
            font-size: 1.6rem;
            color: #1469e2;
          }
          .text-item-container {
            font-size: 1.4rem;
            div {
              color: #939393;
              height: 2.1rem;
              display: flex;
              align-items: flex-end;
            }
          }
        }
        .no-border {
          border: 0;
        }
      }
    }
    .homebtn {
      display: flex;
      // border:1px solid  green;
      justify-content: space-around;
      padding-top: 4.4rem;
      > div {
        position: relative;
        width: 14rem;
        height: 7rem;
        font-size: 2.2rem;
        text-align: center;
        box-sizing: border-box;
        padding: 0.8rem;
        color: #ffffff;
        // border:1px solid  red;
        box-shadow: 2px 4px 5px 1px #b6b6b6;
        border-radius: 0.8rem;
        p {
          font-size: 1.8rem;
        }
        .buy-policy-btn-bottom {
          font-size: 2.2rem;
          position: absolute;
          bottom: 1.2rem;
          right: 1.2rem;
        }
      }
      .buy-policy-btn {
        background: #646ad8;
      }
      .submit-btn {
        background: #d5a169;
      }
    }
    .footer {
      position: absolute;
      bottom: 0;
      margin-left: 2rem;
    }
  }

  .mint-popup {
    // position: relative;
    width: 80%;
    min-height: 30rem;
    .container {
      width: 100%;
      height: 40%;
      border-radius: 3rem;
      background: #fff;
      padding: 2rem;
      box-sizing: border-box;
      .disabled {
        background-color: #ddd;
        border-color: #ddd;
        color: #57a3f3;
        cursor: not-allowed; // 鼠标变化
      }
      .title {
        display: flex;
        justify-content: center;
      }
      .login-btn {
        width: 100%;
        display: flex;
        justify-content: center;
        .el-form-item__content {
          width: 40%;
          button {
            width: 100%;
          }
        }
      }
      .code {
        .el-form-item__label {
          display: block;
          text-align: left;
          float: none;
        }
        .el-form-item__content {
          display: flex;
        }
        button {
          margin-left: 1rem;
        }
      }
    }
  }
}
</style>
